/**
 * PrpOnlyGuard - on a PRP Programs plan, full-EHR screens redirect to the
 * PRP workspace (typed URLs and old links included). Menus hide them too.
 */
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { usePlanWorkspace } from "@/hooks/use-platform-billing";
import { prpOnlyRedirect } from "@/lib/prp-only";

export function PrpOnlyGuard() {
  const { pathname } = useLocation();
  const { prpOnly, isLoading } = usePlanWorkspace();
  const target = prpOnlyRedirect(pathname);

  // Hold a blocked page until the plan is known so it never flashes.
  if (isLoading && target) return null;
  if (prpOnly && target) return <Navigate to={target} replace />;
  return <Outlet />;
}
